import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

const SemanticDatabaseDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  record
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          bgcolor: 'var(--wb-bg-panel)',
          color: 'var(--wb-text-strong)',
          borderRadius: 2
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid var(--wb-overlay-10)' }}>
        Confirmar eliminación
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="body1">
          ?Deseas realizar un borrado l?gico de
          <Typography component="span" sx={{ fontWeight: 600, mx: 0.5 }}>
            {record?.name || 'esta base semántica'}
          </Typography>
          ?
        </Typography>
        <Typography variant="body2" color="var(--wb-text-soft)" sx={{ mt: 2 }}>
          La base quedar? marcada como eliminada y podr?s consultarla desde la pesta?a "Eliminadas".
        </Typography>
      </DialogContent>
      <DialogActions sx={{ borderTop: '1px solid var(--wb-overlay-10)', p: 2 }}>
        <Button onClick={onClose} sx={{ color: 'var(--wb-x-text-ffffffbf, rgba(255, 255, 255, 0.75))' }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{ bgcolor: 'var(--wb-danger)', '&:hover': { bgcolor: 'var(--wb-x-bg-ef4444, #ef4444)' } }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SemanticDatabaseDeleteDialog;